import React, { useState, useEffect } from 'react';
import * as Store from '@apply/store';
import { BusinessAndPeopleSectionType } from './constants/BusinessAndPeopleSectionType';
import { BusinessAndPeopleSectionTypeOptions } from './constants/BusinessAndPeopleSectionTypeOptions';
import BorrowerEntityPanel from './BorrowerEntityPanel';
import BorrowerEntityOwnerPanel from './BorrowerEntityOwnerPanel';
import OtherEntityOwnerPanel from './OtherEntityOwnerPanel';
import S1UploadsPanel from './S1UploadsPanel';
import { AdditionalPeoplePanel } from './AdditionalPeoplePanel';
import { GeneralContractorsPanel } from './GeneralContractorsPanel';
import VerifyCompanyStructurePanel from './VerifyCompanyStructurePanel';
import { LicenseToBuildPanel } from './LicenseToBuildPanel';
import ReferencesPanel from './ReferencesPanel';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { useAuthentication } from '../LoginPage';

export interface BusinessAndPeoplePanelProps {
    currentTopLevelBusiness: number;
    applicationInsights: ApplicationInsights;
}

const BusinessAndPeoplePanel: React.FC<BusinessAndPeoplePanelProps> = (props) => {
    const [activeSections, set_activeSections] = useState([]);
    const [selectedSection, set_selectedSection] = useState(BusinessAndPeopleSectionType.BorrowerEntities);
    const [currentBusinessId, set_currentBusinessId] = useState(0);
    const { isFeatureEnabled } = useAuthentication();
    const styles = {
        hierarchyContentPanel: {
            width: '100%',
            border: '1px solid lightgray',
            borderRadius: '10px 10px 0px 0px',
        },
        sectionPicker: {
            display: 'flex',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '15px',
            background: 'ghostwhite',
            borderBottom: '1px lightgray solid',
            borderRadius: '10px 10px 0px 0px',
        },
    };

    useEffect(() => {
        if (currentBusinessId != props.currentTopLevelBusiness) {
            set_currentBusinessId(props.currentTopLevelBusiness);
        }
    }, [props.currentTopLevelBusiness]);

    useEffect(() => {
        const auth = Store.UserStore.Types.retrieve();
        if (auth?.user) {
            set_activeSections(BusinessAndPeopleSectionTypeOptions.filter((item) => isFeatureEnabled(item.featureFlag)));
        }
    }, []);

    const onSectionChange = (e) => {
        if (selectedSection != e.target.value) {
            set_selectedSection(e.target.value);
        }
    };

    return (
        <div style={styles.hierarchyContentPanel}>
            <div style={styles.sectionPicker}>
                <label
                    style={{ paddingTop: '2px', paddingRight: '15px' }}
                    htmlFor='BusinessAndPeopleSection'
                >
                    Section:
                </label>
                <div>
                    <select
                        id='BusinessAndPeopleSection'
                        onChange={onSectionChange}
                        value={selectedSection}
                        style={{ width: '300px' }}
                    >
                        {activeSections.map((c) => {
                            return (
                                <option
                                    key={c.id + '_' + c.text}
                                    value={c.id}
                                >
                                    {c.text}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <div style={{ margin: '15px' }}>
                {(selectedSection != undefined && +selectedSection === BusinessAndPeopleSectionType.BorrowerEntities && (
                    <BorrowerEntityPanel
                        applicationInsights={props.applicationInsights}
                        currentTopLevelBusiness={currentBusinessId}
                    />
                )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.OwnersOfBorrowerEntities && (
                        <BorrowerEntityOwnerPanel
                            applicationInsights={props.applicationInsights}
                            currentTopLevelBusiness={currentBusinessId}
                        />
                    )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.OwnersOfOtherEntities && <OtherEntityOwnerPanel />) ||
                    (+selectedSection === BusinessAndPeopleSectionType.S1Uploads && <S1UploadsPanel />) ||
                    (+selectedSection === BusinessAndPeopleSectionType.AdditionalPeople && (
                        <AdditionalPeoplePanel
                            applicationInsights={props.applicationInsights}
                            currentTopLevelBusiness={currentBusinessId}
                        />
                    )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.GeneralContractors && (
                        <GeneralContractorsPanel
                            applicationInsights={props.applicationInsights}
                            currentTopLevelBusiness={currentBusinessId}
                        />
                    )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.VerifyCompanyStructure && (
                        <VerifyCompanyStructurePanel />
                    )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.LicenseToBuild && (
                        <LicenseToBuildPanel
                            applicationInsights={props.applicationInsights}
                            currentTopLevelBusiness={currentBusinessId}
                        />
                    )) ||
                    (+selectedSection === BusinessAndPeopleSectionType.References && (
                        <ReferencesPanel
                            applicationInsights={props.applicationInsights}
                            currentTopLevelBusiness={currentBusinessId}
                        />
                    ))}
            </div>
        </div>
    );
};

export default BusinessAndPeoplePanel;
